import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/_services';
import {MatSnackBar} from '@angular/material';
@Component({
  selector: 'app-language-master',
  templateUrl: './language-master.component.html',
  styleUrls: ['./language-master.component.scss']
})
export class LanguageMasterComponent implements OnInit {
  array = [];
  sum = 10;
  page = 0;
  languageList:any = [];
  totalRecords:any = 0;
  size = 10;
  startdate="";
  enddate="";
  languageFilter: any = {
    language_code:"",
    language_name:"",
    status:"Active"
  };
  productLoading:Boolean=false
  constructor(
    private commonService:CommonService,
    private snackbar:MatSnackBar,
  ) {}

  ngOnInit() {
    this.getlanguageList(1,this.languageFilter);
  }

  getlanguageList(page: number,languageFilter){
    this.productLoading=true

    this.commonService.getLanguageList((page - 1) ,this.size,languageFilter).subscribe((response) => {
      if(response.status_code == 200){
        
        console.log("response.status_code",response)
        
        this.productLoading=false

        this.languageList = response.Data.language_data
        this.totalRecords = response.Data.total_count
        this.page=page
      }else{

        this.productLoading=false
        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });

        this.languageList = [];
        this.totalRecords = 0 ;
      }
    },
    (err: any) => console.log("error",err),() =>
      console.log("getCustomersPage() retrieved customers for page:", + page)
    );
  }

  pageChanged(event:any){
    this.getlanguageList(event,this.languageFilter)
  }

  onSubmit(){
    this.languageFilter.planstartdate=this.startdate
    this.languageFilter.planenddate=this.enddate
    this.getlanguageList(1,this.languageFilter)
  }

  clearfilter(){
    this.languageFilter.language_code=""
    this.languageFilter.status=""
    this.getlanguageList(1,this.languageFilter)
  }
}



// WEBPACK FOOTER //
// ./src/app/component/language/language-master/language-master.component.ts